import Refresh from './Refresh';
export default {
  'reauth': {
    screen: Refresh,
  },
};
